module.exports = __webpack_public_path__ + "static/img/zipteam-logo.0474ee3b.svg";